module.exports = __webpack_public_path__ + "0d040ab20ca2d24321a65c76f489b04e.svg";